import React, { Component } from 'react';
import { connect } from 'react-redux';
import Row from '../../../../common/grid/Row.js';
import Col from '../../../../common/grid/Col.js';
import Input from '../../../../common/input/Input.js';
import Button from '../../../../common/button/Button.js';
import ImageUpload from "../../../../common/image/ImageUpload.js";
import CheckboxContainer from '../../../../common/checkbox/CheckboxContainer.js';
import { fetchRoles } from '../../../../actions/role.js';
import { updateUser, fetchUser } from '../../../../actions/user.js';
import { setErrors, clearErrors } from '../../../../actions/error.js';

import './EditUser.css';

class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      password: '',
      password_confirmation: '',
      roles: [],
      profile_photo: '',
      range: 0
    };

    this.renderRoles = this.renderRoles.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onPhotoUpload = this.onPhotoUpload.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  renderRoles() {
    if (!this.props.roles) {
      return null;
    } else {
      return (<CheckboxContainer
        title='Edit Roles'
        name='roles'
        checkboxData={this.props.roles.map(r => ({ value: r.id, display_name: r.display_name }))}
        onCheckboxChange={this.onCheckboxChange}
        checkAgainst={this.state.roles.map(r => ({ value: r.id, display_name: r.display_name }))}
      />);
    }
  }

  handleInputChange(text, name) {
    this.setState({ [name]: text });
  }

  onCheckboxChange(value, name) {
    const arr = this.state[name];
    const item = arr.filter(item => (item.id === value))[0];

    // check if state[name] has value
    if (item) {
      arr.splice(arr.indexOf(item), 1);
      this.setState({ [name]: arr });
    } else {
      this.setState({ [name]: arr.concat({ id: value }) });
    }
  }

  onPhotoUpload({ file, range }) {
    this.setState({ profile_photo: file, range });
  }

  validate() {
    let errors = {};
    if (!this.state.first_name) {
      errors['first_name'] = ['First Name is required!'];
    }

    if (!this.state.last_name) {
      errors['last_name'] = ['Last Name is required!'];
    }

    if (!this.state.email) {
      errors['email'] = ['Email is required!'];
    }

    if (!this.state.phone) {
      errors['phone'] = ['Phone is required!'];
    }

    if (this.state.roles.length < 1) {
      errors['roles'] = ['Please, select at least one role!'];
    }

    this.props.addErrors(errors);
    return Object.keys(errors).length === 0;
  }

  onSubmitClick(e) {
    e.preventDefault();
    if (this.validate()) {
      const user = {
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        phone: this.state.phone,
        email: this.state.email,
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
        roles: this.state.roles.map(r => r.id),
        profile_photo: this.state.profile_photo,
        range: this.state.range,
      }

      this.props.emptyErrors();
      this.props.updateUser(this.state.id, user, true);
    }
  }

  componentDidMount() {
    this.props.fetchRoles();
    this.props.fetchUser(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      Object.keys(nextProps.user).forEach(k => this.setState({ [k]: nextProps.user[k] }));
    }
  }

  render() {
    
    return (
      <div className='edit-user'>
        <h2>Edit User</h2>
        <Row _gap-32 _no-grow-first>
          <Col _bottom-8>
            <ImageUpload
              uploadText='Change Photo'
              apply={this.onPhotoUpload}
              profile_photo_url={this.state.profile_photo_url} />
          </Col>
          <Col _bottom-16>
            <Row _right-16 _warp>
              <Input
                name='first_name'
                value={this.state.first_name}
                onChange={this.handleInputChange}
                ph='First Name' />
              <Input
                name='last_name'
                value={this.state.last_name}
                onChange={this.handleInputChange}
                ph='Last Name' />
            </Row>
            <Row _right-16 _warp>
              <Input
                name='phone'
                value={this.state.phone}
                onChange={this.handleInputChange}
                ph='Phone' />
            </Row>
            <Row _right-16 _warp>
              <Input
                name='email'
                value={this.state.email}
                onChange={this.handleInputChange}
                type='email'
                ph='Email' />
            </Row>
            <Row _right-16 _warp>
              <Input
                name='password'
                type='password'
                value={this.state.password}
                onChange={this.handleInputChange}
                ph='New Password' />
              <Input
                name='password_confirmation'
                type='password'
                value={this.state.password_confirmation}
                onChange={this.handleInputChange}
                ph='New Password Confirmation' />
            </Row>

            <Row _right-16 _warp>
              {this.renderRoles()}
            </Row>

            <Row _space-between>
              <Button
                className="btn-green btn-square"
                onClick={this.onSubmitClick}>
                Save
                            </Button>
            </Row>
          </Col>
        </Row>
      </div >
    );
  }
}

const mapStateToProps = state => {
  return {
    roles: state.role,
    user: state.user.selectedUser
  }
}

const mapDispatchToProps = {
  addErrors: (errors) => dispatch => dispatch(setErrors(errors)),
  emptyErrors: () => dispatch => dispatch(clearErrors()),
  fetchRoles,
  updateUser,
  fetchUser
}

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);


// WEBPACK FOOTER //
// ./src/components/main/user-management/edit/EditUser.js